<template>
  <div class="onboarding-signup-wrapper">
    <Suspense>
      <SignupAsync :nextOnboardingPage="nextOnboardingPage" />
      <template #fallback>
        <div class="onboarding-signup-wrapper__loading" aria-hidden="true">
          <ButtonSpinner />
        </div>
      </template>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import {
  passwordlessSignup18304Experiment,
  signupPageNullExperiment17503Experiment,
} from '@/services/ab'
import Signup from './Signup.vue'

const SignupAsync = defineAsyncComponent(async () => {
  const startupPromises = [
    signupPageNullExperiment17503Experiment(),
    passwordlessSignup18304Experiment(),
  ]

  await Promise.allSettled(startupPromises)
  return Signup
})

defineProps<{
  nextOnboardingPage: () => void
}>()
</script>

<style lang="scss" scoped>
.onboarding-signup-wrapper {
  width: 100%;
  height: 100%;

  &__loading {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
}
</style>
